import { render, staticRenderFns } from "./OmniChatClientes.vue?vue&type=template&id=616ec6ba&scoped=true"
import script from "./OmniChatClientes.vue?vue&type=script&lang=js"
export * from "./OmniChatClientes.vue?vue&type=script&lang=js"
import style0 from "./OmniChatClientes.vue?vue&type=style&index=0&id=616ec6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616ec6ba",
  null
  
)

export default component.exports